//InputAPI Types

export const GET_JOBCARDTYPE_REQUEST = 'GET_JOBCARDTYPE_REQUEST';
export const GET_JOBCARDTYPE_SUCCESS = 'GET_JOBCARDTYPE_SUCCESS';
export const GET_JOBCARDTYPE_FAIL = 'GET_JOBCARDTYPE_FAIL';

export const GET_VEHICLENO_REQUEST = 'GET_VEHICLENO_  REQUEST'
export const GET_VEHICLENO_SUCCESS = 'GET_VEHICLENO_SUCCESS'
export const GET_VEHICLENO_FAIL = 'GET_VEHICLENO_FAIL'